module.exports = __webpack_public_path__ + "static/img/college6.5f37b11.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/college/college6.jpeg
// module id = mgek
// module chunks = 45